/**
Copyright (C) 2022 by SeQuenX  - All Rights Reserved
This file is part of the ComplyVantage product development,
and is released under the "Commercial License Agreement".
You should have received a copy of the Commercial License Agreement license with
this file. If not, please write to: legal@sequenx.com, or visit www.sequenx.com
*/
import React from "react";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaExternalLinkAlt,
} from "react-icons/fa";
import { motion } from "framer-motion";

const branchData = [
  {
    title: "Netherlands",
    company: "SeQuenX B.V.",
    address: "Mozartlaan 9, 2215LS, Voorhout, The Netherlands",
    email: "europe@sequenx.com",
    link: "https://www.sequenx.com/contact-us/",
    // phoneNo: "+31 (0) 71 123 4567",
    iFrameSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9775.477345915526!2d4.486848816741812!3d52.22759167131634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c5c105dff3aaab%3A0x7f744df5cf7878bc!2sMozartlaan%209%2C%202215%20LS%20Voorhout%2C%20Netherlands!5e0!3m2!1sen!2s!4v1692177562280!5m2!1sen!2s",
    color: "from-slate-700 to-slate-800",
    icon: "🇳🇱",
  },
  {
    title: "America",
    company: "SeQuenX America",
    address: "399 West Trimble Road, San Jose, California 95131, USA",
    link: "https://www.sequenx.com/contact-us/",
    email: "americas@sequenx.com",
    // phoneNo: "+1 (408) 123-4567",
    iFrameSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3170.2705994239227!2d-121.9346887!3d37.3834324!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fcbd80b0e5c1b%3A0xb9a3dadbfd5b3f29!2s399%20W%20Trimble%20Rd%2C%20San%20Jose%2C%20CA%2095131%2C%20USA!5e0!3m2!1sen!2s!4v1696314784253!5m2!1sen!2s",
    color: "from-slate-600 to-slate-700",
    icon: "🇺🇸",
  },
  {
    title: "India",
    company: "SeQuenX APAC",
    address:
      "B-1/H-3, Mohan Co-Operative, Mathura Road, Industrial Area, Block-B, New Delhi 110044.",
    link: "https://www.sequenx.com/contact-us/",
    email: "india@sequenx.com",
    // phoneNo: "+91 11 1234 5678",
    iFrameSrc:
      "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d219.1095530030938!2d77.29450493131876!3d28.517082778840944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1696315373035!5m2!1sen!2s",
    color: "from-slate-800 to-slate-900",
    icon: "🇮🇳",
  },
  {
    title: "Pakistan",
    company: "SeQuenX AI",
    address:
      "4th Floor, CIS Tech Park, Shahrah-e-Jamhuriat, Sector G-5/2, Islamabad 44050.",
    link: "https://www.sequenx.com/contact-us/",
    email: "pakistan@sequenx.com",
    // phoneNo: "+92 51 1234567",
    iFrameSrc:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13273.774135151687!2d73.0987488!3d33.7233453!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfc19e34567c17%3A0xce869e4da9857b0e!2sCIS%20Technology%20Park!5e0!3m2!1sen!2s!4v1696315469794!5m2!1sen!2s",
    color: "from-slate-700 to-slate-800",
    icon: "🇵🇰",
  },
  {
    title: "UAE",
    company: "SeQuenX Information Technology Services FZE",
    address:
      "DUQE Square Business Center FZE, Quarter Deck, Mina Rashid - Queen Elizabeth II, PO Box 554789, Dubai UAE",
    link: "https://www.sequenx.com/contact-us/",
    email: "uae@sequenx.com",
    // phoneNo: "+971 52 755 9917",
    iFrameSrc:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3608.1234567890123!2d55.2708!3d25.2048!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43348a67e24b%3A0xff6e9d35b310860c!2sMina%20Rashid%2C%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2s!4v1696315469794!5m2!1sen!2s",
    color: "from-slate-600 to-slate-700",
    icon: "🇦🇪",
  },
];

const Branches = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800  mb-4">
            Our Global Presence
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {branchData.map((branch, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className={`bg-gradient-to-br ${branch.color} rounded-xl shadow-lg p-8 md:p-10 transform hover:scale-[1.01] transition-all duration-300`}
            >
              <div className="space-y-6">
                <div>
                  <div className="flex items-center mb-3">
                    <div>
                      <h3 className="text-2xl font-bold text-white mb-2">
                        {branch.title}
                      </h3>
                      <h4 className="text-xl text-gray-200 mb-4">
                        {branch.company}
                      </h4>
                    </div>
                  </div>
                </div>

                <div className="space-y-4">
                  <div className="flex items-center space-x-3">
                    <FaMapMarkerAlt className="text-gray-300 text-xl" />
                    <p className="text-gray-200">{branch.address}</p>
                  </div>
                  <div className="flex items-center space-x-3">
                    <FaEnvelope className="text-gray-300 text-xl" />
                    <p className="text-gray-200">{branch.email}</p>
                  </div>
                  {branch.phoneNo && (
                    <div className="flex items-center space-x-3">
                      <FaPhone className="text-gray-300 text-xl" />
                      <p className="text-gray-200">{branch.phoneNo}</p>
                    </div>
                  )}
                </div>

                <a
                  href={branch.link}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center space-x-2 bg-white/20 hover:bg-white/30 text-white px-6 py-3 rounded-xl transition-all duration-300 border border-white/30 backdrop-blur-sm"
                >
                  <span>Contact Office</span>
                  <FaExternalLinkAlt className="text-sm" />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Branches;
